async function initUTMCode() {
  const url = new URL(window.location.href)
  const utmCodeUrl = url.searchParams.get('utm_code')?.toLowerCase()

  if (!utmCodeUrl) {
    return
  }

  const appliedUtmCode = await pollingCodes()

  await ResourceCoordinator.requestVendor('Toastr')

  if (utmCodeUrl !== appliedUtmCode) {
    window.discountOnCartProApp.applyCode(utmCodeUrl)
  }

  const code = await pollingCodes()
  if (!code || code !== utmCodeUrl) {
    toastr.error('The coupon code you entered cannot be confirmed.')
    return
  }

  toastr.success(`Add an item to cart to activate code ${url.searchParams.get('utm_code')}.`)
}

function pollingCodes() {
  return new Promise((resolve, _reject) => {
    const interval = setInterval(() => {
      const codes = window.discountOnCartProApp?.codes
      if (codes) {
        if (codes.length === 0) resolve('')
        else resolve(codes[0].toLowerCase())
        clearInterval(interval)
      }
    }, 1000)
  })
}

initUTMCode()
